import React, { Component } from "react";
import { Link } from "react-router-dom";

export default class CreateCampaignButton extends Component {
    render() {
        const { createParams } = this.props;
        return <Link
            to={{
                pathname: "/campaigns/create",
                state: { ...(createParams || {}) },
            }}
            className={"btn btn-primary btn-lg"}
        >
            {/*d-block*/}
            + New Campaign
        </Link>
    }
}